import request from '../utils/request'
const baseUrl = process.env.NODE_ENV === 'production' ? '' : '/packmap'
// const baseUrl = ''
export function getparkNum (parkfieldId) {
  return request({
    url: baseUrl + '/parkinfo/getparkNum',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}
export function getparkIncome (parkfieldId) {
  return request({
    url: baseUrl + '/parkinfo/getparkIncome',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}
export function getparkList () {
  return request({
    url: baseUrl + '/lcparkfield',
    method: 'get'
  })
}
export function getCharageStatus (parkfieldId) {
  return request({
    url: baseUrl + '/lcparkfield/charageStatus',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/parkInfo.js